import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';

const team = {
    crewList: [
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Гребенькова Александра',
            crewItemSubtitle: 'Менеджер проекта',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: '2 копирайтера',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Дизайнер',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'SEO-специалист',
            crewItemSubtitle: '',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'PPC-специалист',
            crewItemSubtitle: '',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <div className="gapresource-team">
                <FullWrapper>
                    <CommonTitle>Команда</CommonTitle>
                    <CrewContainer container={team} />
                </FullWrapper>
            </div>
        );
    }
}

export default Team;
